import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';

/**
 * Checks if notification is supported by the browser and enabled in mini-feature-flags.
 * @param windowObj global window object
 * @returns boolean true if web push is supported else false
 */
const isWebPushNotificationSupported = (windowObj: Window) => {
    if (
        isMiniHostAppFeatureEnabled('native') ||
        !isMiniFeatureEnabled('mini-push-notification-mail')
    ) {
        return false;
    }
    return (
        'navigator' in windowObj &&
        'serviceWorker' in windowObj.navigator &&
        'PushManager' in windowObj
    );
};
export default isWebPushNotificationSupported;
